(function () {
  var root = document.getElementById('pcd-root');
  if (!root) return;

  var API_BASE   = root.dataset.api;
  var COLOR_OUT  = root.dataset.accent;
  var COLOR_HARV = root.dataset.cta;
  var COLOR_SOFT = root.dataset.soft;

  /* ── Date helpers ── */
  /* Принимает и ISO (yyyy-mm-dd), и MM-DD */
  function isoToFrac(iso) {
    if (!iso) return null;
    var p = iso.split('-').map(Number);
    var m = p.length > 2 ? p[1] : p[0], d = p.length > 2 ? p[2] : p[1];
    return m + (d - 1) / 30;
  }
  function fmtIso(iso) {
    if (!iso) return '—';
    var p = iso.split('-').map(Number);
    var m = p.length > 2 ? p[1] : p[0], d = p.length > 2 ? p[2] : p[1];
    return ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][m-1] + ' ' + d;
  }
  /* MM-DD-диапазон → месячные доли; окно через Новый год режется на два.
     Окнам короче ~недели даём минимальную ширину, чтобы месяц закрашивался. */
  function mdRangeToFracs(r) {
    if (!r) return [];
    var a = isoToFrac(r.from), b = isoToFrac(r.to);
    if (b >= a) return [[a, Math.max(b, a + 0.25)]];
    return [[a, 13], [1, Math.max(b, 1.25)]];
  }
  function fmtIsoRange(r) {
    if (!r) return null;
    if (typeof r === 'string') return fmtIso(r);
    var a = fmtIso(r.from), b = fmtIso(r.to);
    return a === b ? a : a + ' – ' + b;
  }
  function esc(s) {
    return String(s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Crop processing ──
     Окна приходят с сервера в crop.seasons (spring/fall/winter/year-round),
     даты MM-DD, окна могут переходить через Новый год. */
  function processApiCrop(crop) {
    var seasons = crop.seasons || [];
    var indoor = [], outdoor = [], harvest = [];
    seasons.forEach(function(s) {
      if (s.indoorStart) indoor  = indoor.concat(mdRangeToFracs(s.indoorStart));
      if (s.sowOutdoor)  outdoor = outdoor.concat(mdRangeToFracs(s.sowOutdoor));
      if (s.harvest)     harvest = harvest.concat(mdRangeToFracs(s.harvest));
    });

    return {
      id: 'c' + crop.id, // серверный seedsID — уникален (имена культур коллизят)
      name: crop.name,
      category: crop.category || 'Other',
      spacing: crop.spacing || null,
      image: crop.image || null,
      buyUrl: crop.buyUrl || null,
      guideUrl: crop.guideUrl || null,
      bestTip: crop.bestTip || null,
      notes: crop.notes || '',
      indoor: indoor, outdoor: outdoor, harvest: harvest,
      seasonsRaw: seasons,
      hasData: !!(indoor.length || outdoor.length || harvest.length),
    };
  }

  var SEG = { indoor: '#f4c16a', outdoor: COLOR_OUT, harvest: COLOR_HARV };

  /* Фильтр по календарным сезонам: показываем культуры, чьё окно посева
     пересекается с месяцами сезона (доли месяца 1..13) */
  var SEASON_MONTHS = {
    spring: [[3, 6]],
    summer: [[6, 9]],
    fall:   [[9, 12]],
    winter: [[12, 13], [1, 3]],
  };
  /* Матч по месяцам ИЛИ по серверной метке сезона: в зоне 10a «весенний» посев
     идёт в декабре-феврале, и кнопка Spring должна его находить */
  function cropSowsInSeason(crop, season) {
    var segs = SEASON_MONTHS[season] || [];
    return crop.seasonsRaw.some(function(s) {
      if (s.season === season || s.season === 'year-round') return true;
      return mdRangeToFracs(s.sowOutdoor).some(function(r) {
        return segs.some(function(seg) { return r[0] < seg[1] && r[1] > seg[0]; });
      });
    });
  }
  /* Попадает ли окно сезона культуры в выбранный фильтр */
  function seasonWindowInFilter(s) {
    if (S.season === 'all') return true;
    if (s.season === S.season || s.season === 'year-round') return true;
    var segs = SEASON_MONTHS[S.season] || [];
    return mdRangeToFracs(s.sowOutdoor).some(function(r) {
      return segs.some(function(seg) { return r[0] < seg[1] && r[1] > seg[0]; });
    });
  }
  function seasonLabel(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  /* «01-01 – 12-31» показываем словом, а не датами */
  function fmtSeasonRange(r) {
    if (!r) return '—';
    if (r.from === '01-01' && r.to === '12-31') return 'Year-round';
    return fmtIsoRange(r);
  }

  function rangeToMonths(range) {
    if (!range) return [];
    var s = range[0], e = range[1], out = [];
    for (var i = 0; i < 12; i++) {
      var cov = Math.max(0, Math.min(e, i+2) - Math.max(s, i+1));
      if (cov > 0) out.push({ idx: i, cov: cov });
    }
    return out;
  }

  function renderHeatmap(crop) {
    var rows = [
      { key: 'indoor',  ranges: crop.indoor },
      { key: 'outdoor', ranges: crop.outdoor },
      { key: 'harvest', ranges: crop.harvest },
    ];
    var html = '<div class="pcd-tl pcd-tl-heatmap">';
    rows.forEach(function(row) {
      var arr = [0,0,0,0,0,0,0,0,0,0,0,0];
      if (crop.hasData) {
        row.ranges.forEach(function(r) {
          rangeToMonths(r).forEach(function(m) { arr[m.idx] = Math.max(arr[m.idx], m.cov); });
        });
      }
      var color = SEG[row.key];
      html += '<div class="pcd-tl-heat-row">';
      arr.forEach(function(v) {
        var op = crop.hasData ? (v === 0 ? 0.07 : (0.3 + v * 0.7).toFixed(2)) : 0.08;
        html += '<span class="pcd-tl-heat-cell" style="background-color:' + color + ';opacity:' + op + '"></span>';
      });
      html += '</div>';
    });
    return html + '</div>';
  }

  /* ── State ── */
  /* Шаринг-ссылки: ?zone=6b или ?zip=NNNNN, оба приоритетнее сохранённого ZIP.
     Зона раскрывается в эталонный ZIP полузоны — даты в данных зонные, любой ZIP
     зоны даёт тот же календарь. localStorage в try/catch — в стороннем iframe
     (embed) доступ может кидать SecurityError. */
  var ZONE_ZIP = { '1a':'99720', '1b':'99722', '2a':'99519', '2b':'99586', '3a':'55732', '3b':'04737', '4a':'03576', '4b':'03561', '5a':'03215', '5b':'01026', '6a':'01002', '6b':'01001', '7a':'01901', '7b':'00501', '8a':'08014', '8b':'23313', '9a':'27915', '9b':'29920', '10a':'32115', '10b':'33026', '11a':'33002', '11b':'00601', '12a':'00611', '13a':'00603' };
  var zoneLinkPending = false; // пришли по ?zone= — эталонный ZIP служебный, не показываем его
  var S = {
    zip: (function() {
      try {
        var sp = new URLSearchParams(location.search);
        var z = (sp.get('zone') || '').toLowerCase();
        if (!ZONE_ZIP[z] && ZONE_ZIP[z + 'a']) z += 'a'; // ?zone=6 без буквы -> 6a
        if (ZONE_ZIP[z]) { zoneLinkPending = true; return ZONE_ZIP[z]; }
        var q = sp.get('zip');
        if (q && /^\d{5}$/.test(q)) return q;
      } catch (e) {}
      try { return localStorage.getItem('pc-zip') || ''; } catch (e) { return ''; }
    })(),
    apiData: null, allCrops: [],
    season: 'all', search: '', category: 'all',
    expandedId: null, activities: new Set(), cityName: '',
  };

  /* ── DOM refs ── */
  function $id(id) { return document.getElementById(id); }
  var zipInput    = $id('pcd-zip'),         zipBtn      = $id('pcd-zip-btn');
  var zoneCard    = $id('pcd-zone-card'),   zoneCityEl  = $id('pcd-zone-city');
  var zoneValEl   = $id('pcd-zone-val'),    lfValEl     = $id('pcd-lf-val');
  var ffValEl     = $id('pcd-ff-val'),      searchInput = $id('pcd-search');
  var searchClear = $id('pcd-search-clear'),catListEl   = $id('pcd-cat-list');
  var errorEl     = $id('pcd-error'),       loadingEl   = $id('pcd-loading');
  var ribbonWrap  = $id('pcd-ribbon-wrap'), ribbonEl    = $id('pcd-ribbon');
  var mainTitleEl = $id('pcd-main-title'),  mainSubEl   = $id('pcd-main-sub');
  var nudgeEl     = $id('pcd-nudge'),       cropListEl  = $id('pcd-crop-list');
  var emptyEl     = $id('pcd-empty'),       clearBtn    = $id('pcd-clear-btn');
  var exportBtn   = $id('pcd-export-btn');

  renderSkeleton();
  renderCatList();
  if (S.zip) { zipInput.value = S.zip; fetchCalendar(); }

  /* ── Activity helpers ── */
  function todayFrac() {
    var d = new Date();
    return (d.getMonth() + 1) + (d.getDate() - 1) / 30;
  }
  function isCropActivityNow(crop, type) {
    if (!crop.hasData) return false;
    var today = todayFrac(), B = 0.5;
    var ranges = type === 'indoor'  ? crop.indoor
               : type === 'outdoor' ? crop.outdoor
               :                      crop.harvest;
    // проверяем и today±12, чтобы буфер работал через границу года
    return ranges.some(function(r) {
      return [today, today + 12, today - 12].some(function(t) {
        return t >= r[0] - B && t <= r[1] + B;
      });
    });
  }
  function getCropNowBadge(crop) {
    var checks = [
      { type: 'indoor',  label: 'Start indoors', color: SEG.indoor  },
      { type: 'outdoor', label: 'Sow now',        color: SEG.outdoor },
      { type: 'harvest', label: 'Harvest',         color: SEG.harvest },
    ];
    for (var i = 0; i < checks.length; i++) {
      if (isCropActivityNow(crop, checks[i].type)) {
        var txtColor = checks[i].type === 'indoor' ? '#6b4a0a' : '#fff';
        return '<span class="pcd-now-badge" style="background:' + checks[i].color + ';color:' + txtColor + '">' + checks[i].label + '</span>';
      }
    }
    return '';
  }

  /* ── Fetch ── */
  async function fetchCalendar() {
    var zip = zipInput.value.trim();
    if (!/^\d{5}$/.test(zip)) return;
    errorEl.style.display = 'none';
    loadingEl.style.display = '';
    ribbonWrap.style.display = 'none';
    zipBtn.disabled = true;
    S.cityName = ''; // не показывать город от предыдущего ZIP при сбое геокодера
    try {
      var res = await Promise.all([
        fetch(API_BASE + '/api/planting-calendar?zip=' + zip + '&probability=50'),
        fetch('https://api.zippopotam.us/us/' + zip).catch(function() { return null; }),
      ]);
      var resp = res[0], geoResp = res[1];
      var data = null;
      try { data = await resp.json(); } catch (e) { /* не-JSON (429/502 страница) */ }
      if (!resp.ok || !data) throw new Error((data && data.error) || 'Server error (' + resp.status + '). Please try again in a minute.');
      if (geoResp && geoResp.ok) {
        var geo = await geoResp.json();
        var place = geo.places && geo.places[0];
        S.cityName = place ? place['place name'] + ', ' + place['state abbreviation'] : '';
      }
      S.apiData = data;
      S.allCrops = data.crops.map(processApiCrop);
      S.zip = zip; S.category = 'all'; S.search = ''; S.season = 'all';
      searchInput.value = ''; searchClear.style.display = 'none';
      S.expandedId = null;
      if (zoneLinkPending) {
        // зонная ссылка: город и служебный ZIP не показываем и не запоминаем
        zoneLinkPending = false;
        S.cityName = '';
        zipInput.value = '';
      } else {
        try { localStorage.setItem('pc-zip', zip); } catch (e) {}
      }
      // шаримая ссылка: ?zone= в адресной строке, остальные параметры (preview_theme_id и пр.) сохраняем
      try {
        if (data.zone) {
          var spq = new URLSearchParams(location.search);
          spq.delete('zip');
          spq.set('zone', String(data.zone).toLowerCase());
          history.replaceState(null, '', location.pathname + '?' + spq.toString());
        }
      } catch (e) {}
      var legHeat = document.getElementById('pcd-legend-heat');
      if (legHeat) legHeat.style.display = data.heatStart ? '' : 'none';
      renderZoneCard(); renderHeader(); renderRibbon();
      renderCatList(); syncControls(); renderCropList();
      nudgeEl.style.display = 'none';
      var zoneTables = document.getElementById('pcd-zone-tables');
      if (zoneTables) zoneTables.style.display = 'none';
      ribbonWrap.style.display = '';
    } catch(err) {
      errorEl.textContent = err.message || 'Failed to fetch. Please try again.';
      errorEl.style.display = '';
    } finally {
      loadingEl.style.display = 'none';
      zipBtn.disabled = false;
    }
  }

  function renderZoneCard() {
    var data = S.apiData;
    zoneCityEl.textContent = S.cityName || ('ZIP ' + data.zip);
    zoneValEl.textContent  = data.zone;
    var noFrost = data.climate === 'frost-free';
    lfValEl.previousElementSibling.textContent = noFrost ? 'Heat starts' : 'Last frost';
    ffValEl.previousElementSibling.textContent = noFrost ? 'Heat ends'  : 'First frost';
    lfValEl.textContent = fmtIso(noFrost ? data.heatStart : data.lastFrost);
    ffValEl.textContent = fmtIso(noFrost ? data.heatEnd   : data.firstFrost);
    zoneCard.style.display = '';
  }

  function renderHeader() {
    var data = S.apiData;
    mainTitleEl.innerHTML = 'When to plant in <em>Zone ' + esc(data.zone) + '</em>';
    var sub;
    if (data.climate === 'frost-free') {
      sub = 'Personalized sowing and harvest windows for USDA Zone ' + data.zone
        + '. No frost in your zone — the main growing season runs through the cooler months. Extreme heat '
        + fmtIso(data.heatStart) + ' – ' + fmtIso(data.heatEnd) + '.';
    } else if (data.climate === 'hot') {
      sub = 'Personalized sowing, transplanting, and harvest windows for USDA Zone ' + data.zone
        + '. Two planting seasons: spring and fall, with a summer heat pause '
        + fmtIso(data.heatStart) + ' – ' + fmtIso(data.heatEnd) + '. Last frost ' + fmtIso(data.lastFrost)
        + ', first frost ' + fmtIso(data.firstFrost) + '.';
    } else {
      sub = 'Personalized sowing, transplanting, and harvest windows for USDA Zone '
        + data.zone + '. Last frost ' + fmtIso(data.lastFrost) + ', first frost ' + fmtIso(data.firstFrost) + '.';
    }
    mainSubEl.textContent = sub;
  }

  function renderRibbon() {
    var data = S.apiData;
    function pct(frac) { return (frac - 1) / 12 * 100; }
    /* Не пишем текст в полосу, которой он не поместится */
    function bandLabel(widthPct, text) { return widthPct >= 6 ? text : ''; }
    function marker(frac, name, date, right, heat) {
      return '<div class="pcd-ribbon-marker' + (right ? ' pcd-ribbon-marker-right' : '') + (heat ? ' pcd-ribbon-marker-heat' : '') + '" style="left:' + pct(frac).toFixed(2) + '%">' +
        '<div class="pcd-ribbon-marker-line"></div>' +
        '<div class="pcd-ribbon-marker-label"><div class="pcd-ribbon-marker-name">' + name + '</div>' +
        '<div class="pcd-ribbon-marker-date">' + date + '</div></div></div>';
    }
    var hs = data.heatStart ? pct(isoToFrac(data.heatStart)) : null;
    var he = data.heatEnd   ? pct(isoToFrac(data.heatEnd))   : null;
    var html;

    if (data.climate === 'frost-free') {
      html =
        '<div class="pcd-ribbon-free" style="left:0;width:' + hs.toFixed(2) + '%;border-radius:6px 0 0 6px">' + bandLabel(hs, 'No frost') + '</div>' +
        '<div class="pcd-ribbon-heat" style="left:' + hs.toFixed(2) + '%;width:' + (he - hs).toFixed(2) + '%">' + bandLabel(he - hs, 'Too hot to plant') + '</div>' +
        '<div class="pcd-ribbon-free" style="left:' + he.toFixed(2) + '%;width:' + (100 - he).toFixed(2) + '%;border-radius:0 6px 6px 0">' + bandLabel(100 - he, 'No frost') + '</div>' +
        marker(isoToFrac(data.heatStart), 'Heat starts', fmtIso(data.heatStart)) +
        marker(isoToFrac(data.heatEnd), 'Heat ends', fmtIso(data.heatEnd), true);
    } else {
      var lf = isoToFrac(data.lastFrost), ff = isoToFrac(data.firstFrost);
      var lp = pct(lf), fp = pct(ff);
      // полосы «Frost risk» нулевой ширины не рисуем — padding даёт огрызок за краем шкалы
      html = lp > 0.5
        ? '<div class="pcd-ribbon-frost pcd-ribbon-frost-pre" style="width:' + lp.toFixed(2) + '%">' + bandLabel(lp, 'Frost risk') + '</div>'
        : '';
      if (data.climate === 'hot' && hs != null && he != null) {
        html +=
          '<div class="pcd-ribbon-free" style="left:' + lp.toFixed(2) + '%;width:' + (hs - lp).toFixed(2) + '%">' + bandLabel(hs - lp, 'Spring') + '</div>' +
          '<div class="pcd-ribbon-heat" style="left:' + hs.toFixed(2) + '%;width:' + (he - hs).toFixed(2) + '%">' + bandLabel(he - hs, 'Too hot') + '</div>' +
          '<div class="pcd-ribbon-free" style="left:' + he.toFixed(2) + '%;width:' + (fp - he).toFixed(2) + '%">' + bandLabel(fp - he, 'Fall') + '</div>' +
          marker(isoToFrac(data.heatStart), 'Heat starts', fmtIso(data.heatStart), false, true) +
          marker(isoToFrac(data.heatEnd), 'Heat ends', fmtIso(data.heatEnd), false, true);
      } else {
        var gd = Math.round((ff - lf) * 30);
        html += '<div class="pcd-ribbon-free" style="left:' + lp.toFixed(2) + '%;width:' + (fp - lp).toFixed(2) + '%">' + bandLabel(fp - lp, 'Frost-free growing season · ' + gd + ' days') + '</div>';
      }
      html +=
        (100 - fp > 0.5
          ? '<div class="pcd-ribbon-frost pcd-ribbon-frost-post" style="left:' + fp.toFixed(2) + '%;width:' + (100 - fp).toFixed(2) + '%">' + bandLabel(100 - fp, 'Frost risk') + '</div>'
          : '') +
        marker(lf, 'Last frost', fmtIso(data.lastFrost)) +
        marker(ff, 'First frost', fmtIso(data.firstFrost), true);
    }
    ribbonEl.innerHTML = '<div class="pcd-ribbon-track">' + html + '</div>';
  }

  function renderSkeleton() {
    var widths = [120,140,100,160,130,110,150,125,135,145];
    var pillW  = [50,55,45,60,52];
    cropListEl.innerHTML = widths.map(function(nw, i) {
      var hm = ['indoor','outdoor','harvest'].map(function() {
        var cells = '';
        for (var j = 0; j < 12; j++) cells += '<span class="pcd-tl-heat-cell pcd-skel-hm-cell" style="background-color:#ddd"></span>';
        return '<div class="pcd-tl-heat-row">' + cells + '</div>';
      }).join('');
      return '<div class="pcd-crop-row pcd-skel-row"><div class="pcd-crop-row-main" style="pointer-events:none">' +
        '<div class="pcd-crop-cell-name"><span class="pcd-crop-thumb pcd-crop-thumb-ph"></span>' +
        '<div><div class="pcd-skel" style="height:14px;width:' + nw + 'px;margin-bottom:6px"></div>' +
        '<div class="pcd-skel" style="height:12px;width:' + pillW[i%5] + 'px;border-radius:3px"></div></div></div>' +
        '<div><div class="pcd-tl pcd-tl-heatmap">' + hm + '</div></div>' +
        '<div class="pcd-skel" style="height:13px;width:50px"></div><div></div><div></div></div></div>';
    }).join('');
    emptyEl.style.display = 'none';
  }

  function renderCatList() {
    if (!S.allCrops.length) {
      catListEl.innerHTML = '<div class="pcd-cat-hint">Enter your ZIP code to see plant categories</div>';
      return;
    }
    var counts = {};
    S.allCrops.forEach(function(c) { counts[c.category] = (counts[c.category] || 0) + 1; });
    var items = [{ id: 'all', label: 'All crops', count: S.allCrops.length }]
      .concat(Object.keys(counts).sort().map(function(k) { return { id: k, label: k, count: counts[k] }; }));
    catListEl.innerHTML = items.map(function(c) {
      return '<button class="pcd-cat-item' + (S.category === c.id ? ' is-active' : '') + '" data-cat="' + esc(c.id) + '">' +
        '<span>' + esc(c.label) + '</span><span class="pcd-cat-count">' + c.count + '</span></button>';
    }).join('');
    catListEl.querySelectorAll('.pcd-cat-item').forEach(function(btn) {
      btn.addEventListener('click', function() {
        S.category = btn.dataset.cat; S.expandedId = null;
        renderCatList(); renderCropList();
      });
    });
  }

  function filteredCrops() {
    var rows = S.allCrops;
    if (S.activities.size > 0)
      rows = rows.filter(function(c) { return Array.from(S.activities).some(function(act) { return isCropActivityNow(c, act); }); });
    if (S.category !== 'all')
      rows = rows.filter(function(c) { return c.category === S.category; });
    if (S.season !== 'all')
      rows = rows.filter(function(c) { return cropSowsInSeason(c, S.season); });
    if (S.search.trim()) {
      var q = S.search.trim().toLowerCase();
      rows = rows.filter(function(c) {
        return c.name.toLowerCase().indexOf(q) > -1
          || c.category.toLowerCase().indexOf(q) > -1
          || (c.notes && c.notes.toLowerCase().indexOf(q) > -1);
      });
    }
    return rows;
  }

  function renderCropList() {
    var rows = filteredCrops();
    emptyEl.style.display = rows.length === 0 ? '' : 'none';
    cropListEl.innerHTML = rows.map(renderCropRow).join('');
    cropListEl.querySelectorAll('.pcd-crop-row-main').forEach(function(el) {
      var activate = function() {
        var id = el.dataset.id;
        S.expandedId = S.expandedId === id ? null : id;
        renderCropList();
      };
      el.addEventListener('click', activate);
      el.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
      });
    });
    // Клик по Buy ведёт на товар, не раскрывая строку
    cropListEl.querySelectorAll('.pcd-buy-btn').forEach(function(b) {
      b.addEventListener('click', function(e) { e.stopPropagation(); });
    });
  }

  function renderCropRow(crop) {
    var isOpen   = S.expandedId === crop.id;
    var nowBadge = getCropNowBadge(crop);
    var spacing  = crop.spacing || '—';
    var detail   = isOpen ? renderDetailPanel(crop) : '';
    var thumb = crop.image
      ? '<img class="pcd-crop-thumb" src="' + esc(crop.image) + (crop.image.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" loading="lazy">'
      : '<span class="pcd-crop-thumb pcd-crop-thumb-ph"></span>';
    return '<div class="pcd-crop-row' + (isOpen ? ' is-expanded' : '') + '">' +
      '<div class="pcd-crop-row-main" role="button" tabindex="0" data-id="' + esc(crop.id) + '">' +
      '<div class="pcd-crop-cell-name">' + thumb +
      '<div class="pcd-crop-nm"><div class="pcd-crop-name">' + esc(crop.name) + '</div>' +
      '<div class="pcd-crop-meta"><span class="pcd-cat-pill">' + esc(crop.category) + '</span>' + nowBadge + '</div></div></div>' +
      '<div>' + renderHeatmap(crop) + '</div>' +
      '<div class="pcd-spacing-val">' + esc(spacing) + '</div>' +
      '<div>' + (crop.buyUrl ? '<a class="pcd-buy-btn" href="' + esc(crop.buyUrl) + '">Buy</a>' : '') + '</div>' +
      '<div><span class="pcd-chev' + (isOpen ? ' is-open' : '') + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1em" height="1em" fill="currentColor" aria-hidden="true" style="vertical-align:-0.125em"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg></span></div>' +
      '</div>' + detail + '</div>';
  }

  function dw(dotClass, label, value) {
    if (!value)
      return '<div class="pcd-dw pcd-dw-empty"><div class="pcd-dw-label">' + label + '</div><div class="pcd-dw-value">—</div></div>';
    return '<div class="pcd-dw"><div class="pcd-dw-label"><span class="pcd-dw-dot ' + dotClass + '"></span>' + label + '</div>' +
      '<div class="pcd-dw-value">' + value + '</div></div>';
  }

  function renderDetailPanel(crop) {
    var windowsHtml;
    if (!crop.hasData) {
      windowsHtml = '<div class="pcd-dw pcd-dw-empty" style="grid-column:1/-1">' +
        '<div class="pcd-dw-label">Planting dates</div>' +
        '<div class="pcd-dw-hint">' + (S.apiData
          ? 'Planting data for this crop is not available yet'
          : 'Enter your ZIP code to see personalized dates for your zone') + '</div></div>';
    } else {
      // Показываем окна сезонов, попадающих в выбранный фильтр (All = все сезоны культуры)
      var groups = crop.seasonsRaw.filter(seasonWindowInFilter);
      if (!groups.length) groups = crop.seasonsRaw;
      // Пустые окна («—») не рисуем — меньше шума
      windowsHtml = groups.map(function(s) {
        var pre = (s.season === 'year-round' || groups.length === 1) ? '' : seasonLabel(s.season) + ' — ';
        return (s.indoorStart ? dw('pcd-dw-dot-indoor',  pre + 'Start indoors',    fmtSeasonRange(s.indoorStart)) : '') +
               (s.sowOutdoor  ? dw('pcd-dw-dot-outdoor', pre + 'Sow / transplant', fmtSeasonRange(s.sowOutdoor))  : '') +
               (s.harvest     ? dw('pcd-dw-dot-harvest', pre + 'Harvest',          fmtSeasonRange(s.harvest))     : '');
      }).join('');
    }
    var tip = crop.bestTip || crop.notes;
    var tipHead = (tip || crop.guideUrl)
      ? '<div class="pcd-tip-box"><div class="pcd-tip-head"><span class="pcd-detail-notes-label">Best growing tip</span>' +
        (crop.guideUrl ? '<a class="pcd-guide-btn" href="' + esc(crop.guideUrl) + '">Full growing guide →</a>' : '') +
        '</div>' +
        (tip ? '<p class="pcd-detail-notes-text">' + esc(tip) + '</p>' : '') + '</div>'
      : '';
    // На мобилке Buy живёт в развёрнутой панели (в строке места нет), на десктопе скрыта CSS-ом
    var detailBuy = crop.buyUrl
      ? '<a class="pcd-buy-btn pcd-detail-buy" href="' + esc(crop.buyUrl) + '">Buy seeds</a>'
      : '';
    return '<div class="pcd-crop-detail"><div class="pcd-detail-wrap">' +
      '<div><div class="pcd-detail-windows">' + windowsHtml + '</div>' + tipHead + detailBuy + '</div></div></div>';
  }

  function syncControls() {
    document.querySelectorAll('.pcd-season-btn').forEach(function(b) {
      b.classList.toggle('is-active', b.dataset.s === S.season);
    });
    document.querySelectorAll('.pcd-act-chip').forEach(function(chip) {
      chip.classList.toggle('is-active', S.activities.has(chip.dataset.act));
    });
  }

  /* ── Events ── */
  zipBtn.addEventListener('click', fetchCalendar);
  zipInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') fetchCalendar(); });

  document.querySelectorAll('.pcd-act-chip').forEach(function(chip) {
    chip.addEventListener('click', function() {
      var act = chip.dataset.act;
      if (S.activities.has(act)) S.activities.delete(act); else S.activities.add(act);
      S.expandedId = null; syncControls(); renderCropList();
    });
  });

  document.querySelectorAll('.pcd-season-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      S.season = btn.dataset.s; S.expandedId = null; syncControls(); renderCropList();
    });
  });

  searchInput.addEventListener('input', function() {
    S.search = searchInput.value; S.expandedId = null;
    searchClear.style.display = S.search ? '' : 'none';
    renderCropList();
  });
  searchClear.addEventListener('click', function() {
    S.search = ''; searchInput.value = '';
    searchClear.style.display = 'none'; S.expandedId = null; renderCropList();
  });
  clearBtn.addEventListener('click', function() {
    S.search = ''; searchInput.value = '';
    S.category = 'all'; S.season = 'all'; S.activities = new Set(); S.expandedId = null;
    searchClear.style.display = 'none'; syncControls(); renderCatList(); renderCropList();
  });

  /* ── Share my calendar ── */
  var shareBtn = $id('pcd-share-btn');
  function shareUrl() {
    var base = location.origin + location.pathname;
    var zone = S.apiData && S.apiData.zone ? String(S.apiData.zone).toLowerCase() : '';
    return zone ? base + '?zone=' + zone : base;
  }
  if (shareBtn) shareBtn.addEventListener('click', function() {
    var zone = S.apiData && S.apiData.zone ? S.apiData.zone : '';
    var title = zone ? 'Planting Calendar for USDA Zone ' + zone : 'Planting Calendar by ZIP Code';
    var url = shareUrl();
    if (navigator.share) {
      navigator.share({ title: title, text: title + ' — free tool by Organo Republic', url: url }).catch(function() {});
      return;
    }
    function done() {
      shareBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="1em" height="1em" fill="currentColor" aria-hidden="true" style="vertical-align:-0.125em"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg> Link copied!';
      setTimeout(function() {
        shareBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="1em" height="1em" fill="currentColor" aria-hidden="true" style="vertical-align:-0.125em"><path d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"/></svg> Share my calendar';
      }, 1600);
    }
    try { navigator.clipboard.writeText(url).then(done, function() {}); } catch (e) {}
  });

  /* ── Embed this calendar ── */
  var embedBtn   = $id('pcd-embed-btn'),  embedPanel = $id('pcd-embed-panel');
  var embedCode  = $id('pcd-embed-code'), embedCopy  = $id('pcd-embed-copy');
  function embedSnippet() {
    var zone = S.apiData && S.apiData.zone ? String(S.apiData.zone).toLowerCase() : '';
    var src = 'https://api.organoseeds.com/embed' + (zone ? '?zone=' + zone : (S.zip ? '?zip=' + S.zip : ''));
    return '<iframe src="' + src + '" style="width:100%;max-width:760px;height:640px;border:1px solid #dfe5da;border-radius:10px" title="Planting Calendar by ZIP Code" loading="lazy"></iframe>\n' +
      '<p>Free interactive tool by <a href="https://organorepublic.com/pages/planting-calendar">Organo Republic Planting Calendar</a></p>';
  }
  if (embedBtn) embedBtn.addEventListener('click', function() {
    var isOpen = embedPanel.style.display !== 'none';
    embedPanel.style.display = isOpen ? 'none' : '';
    if (!isOpen) embedCode.value = embedSnippet();
  });
  if (embedCopy) embedCopy.addEventListener('click', function() {
    embedCode.value = embedSnippet(); // на случай, если ZIP ввели после открытия панели
    embedCode.select();
    function done() {
      embedCopy.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="1em" height="1em" fill="currentColor" aria-hidden="true" style="vertical-align:-0.125em"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg> Copied!';
      setTimeout(function() {
        embedCopy.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="1em" height="1em" fill="currentColor" aria-hidden="true" style="vertical-align:-0.125em"><path d="M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"/></svg> Copy code';
      }, 1600);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(embedCode.value).then(done, function() { document.execCommand('copy'); done(); });
    } else { document.execCommand('copy'); done(); }
  });

  /* ── Print ── */
  function buildPrintHtml(htm) {
    var a = COLOR_OUT, s = COLOR_SOFT;
    var css = '@page{size:landscape;margin:16mm 18mm}'
      + '*,*::before,*::after{box-sizing:border-box}'
      + 'body{font-family:"Open Sans",Arial,sans-serif;font-size:11px;color:#111;background:#fff;margin:0;padding:0;-webkit-print-color-adjust:exact;print-color-adjust:exact}'
      + '.pcd-pv-hd{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:2px solid ' + a + ';padding-bottom:8px;margin-bottom:14px}'
      + '.pcd-pv-title{font-family:"Oswald",Arial,sans-serif;font-size:22px;font-weight:600;text-transform:uppercase;letter-spacing:.04em;color:#1a1a1a;line-height:1.1}'
      + '.pcd-pv-zone{font-size:12px;color:' + a + ';font-weight:700;margin-top:3px}'
      + '.pcd-pv-meta{text-align:right;font-size:10px;color:#555;line-height:1.7}'
      + '.pcd-pv-meta strong{color:#1a1a1a}'
      + '.pcd-pv-legend{display:flex;gap:18px;margin-bottom:10px;font-size:9px;text-transform:uppercase;letter-spacing:.1em;color:#666;align-items:center;flex-wrap:wrap}'
      + '.pcd-pv-leg-dot{display:inline-block;width:9px;height:9px;border-radius:50%;margin-right:4px;vertical-align:middle}'
      + '.pcd-pv-tbl{width:100%;border-collapse:collapse;font-size:10.5px}'
      + '.pcd-pv-tbl thead{display:table-header-group}'
      + '.pcd-pv-tbl thead th{background:' + a + ';color:#fff;padding:7px 8px;text-align:left;font-size:8.5px;text-transform:uppercase;letter-spacing:.11em;font-weight:700;white-space:nowrap}'
      + '.pcd-pv-tbl tbody tr{break-inside:avoid;page-break-inside:avoid}'
      + '.pcd-pv-tbl tbody td{padding:6px 8px;border-bottom:1px solid #e4e4e0;vertical-align:top}'
      + '.pcd-pv-tbl tbody tr:nth-child(even) td{background:#f7f8f5}'
      + '.pcd-pv-name{font-weight:700;font-size:11.5px;color:#1a1a1a}'
      + '.pcd-pv-notes{font-size:9px;color:#555;font-style:italic;line-height:1.45}'
      + '.pcd-pv-cat{display:inline-block;background:' + s + ';color:' + a + ';padding:1px 6px;border-radius:3px;font-size:8px;text-transform:uppercase;letter-spacing:.09em;font-weight:700;white-space:nowrap}'
      + '.pcd-pv-date{white-space:nowrap;font-size:10.5px}'
      + '.pcd-pv-empty{color:#ccc}'
      + '.pcd-pv-spacing{font-family:"JetBrains Mono",monospace;font-size:9.5px;color:#444;white-space:nowrap}'
      + '.pcd-pv-bar-stack{display:flex;flex-direction:column;gap:1px;margin-top:1px}'
      + '.pcd-pv-bar{display:grid;grid-template-columns:repeat(12,1fr);gap:1px;width:100%;height:4px}'
      + '.pcd-pv-bar-cell{border-radius:1px}'
      + '.pcd-pv-mo-head{display:grid;grid-template-columns:repeat(12,1fr);gap:1px;text-align:center;letter-spacing:0}'
      + '.pcd-pv-ft{margin-top:16px;border-top:1px solid #ddd;padding-top:8px;display:flex;justify-content:space-between;font-size:9px;color:#aaa}';
    var fontsUrl = 'https://fonts.googleapis.com/css2?family=Oswald:wght@500;600'
      + '&family=Open+Sans:ital,wght@0,400;0,500;0,600;0,700'
      + '&family=JetBrains+Mono:wght@400;500&display=swap';
    return '<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><title>Planting Calendar</title>'
      + '<link href="' + fontsUrl + '" rel="stylesheet">'
      + '<style>' + css + '</style>'
      + '</head><body>' + htm + '</body></html>';
  }

  function buildPrintView() {
    var el = document.getElementById('pcd-print-view');
    if (!el) return;
    if (!S.apiData) { el.innerHTML = '<div>Enter your ZIP code first.</div>'; return; }
    var data  = S.apiData;
    var allRows = filteredCrops();
    var crops = allRows.filter(function(c) { return c.hasData; });
    var omitted = allRows.length - crops.length;
    var today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    var filtersActive = S.season !== 'all' || S.category !== 'all' || S.search.trim() || S.activities.size > 0;
    var filterNote = filtersActive ? ' (filtered view)' : '';

    var html = '<div class="pcd-pv-hd">' +
      '<div><div class="pcd-pv-title">Planting Calendar' + filterNote + '</div>' +
      '<div class="pcd-pv-zone">USDA Zone ' + esc(data.zone) + (S.cityName ? ' · ' + esc(S.cityName) : '') + '</div></div>' +
      '<div class="pcd-pv-meta">' + (data.climate === 'frost-free'
        ? '<strong>No frost</strong> &nbsp;·&nbsp; <strong>Heat:</strong> ' + fmtIso(data.heatStart) + ' – ' + fmtIso(data.heatEnd)
        : '<strong>Last frost:</strong> ' + fmtIso(data.lastFrost) +
          ' &nbsp;·&nbsp; <strong>First frost:</strong> ' + fmtIso(data.firstFrost) +
          (data.heatStart ? ' &nbsp;·&nbsp; <strong>Heat:</strong> ' + fmtIso(data.heatStart) + ' – ' + fmtIso(data.heatEnd) : '')) +
      '<br>' + crops.length + ' crops listed &nbsp;·&nbsp; Printed ' + today + '</div></div>' +
      '<div class="pcd-pv-legend">' +
      '<span><span class="pcd-pv-leg-dot" style="background:#f4c16a"></span>Start indoors</span>' +
      '<span><span class="pcd-pv-leg-dot" style="background:' + SEG.outdoor + '"></span>Direct sow / transplant</span>' +
      '<span><span class="pcd-pv-leg-dot" style="background:' + SEG.harvest + '"></span>Harvest window</span>' +
      '<span style="margin-left:auto;font-style:italic;text-transform:none;letter-spacing:0">Shaded months = active window</span></div>' +
      '<table class="pcd-pv-tbl"><thead><tr>' +
      '<th style="width:15%">Crop</th><th style="width:15%">Best Growing Tip</th>' +
      '<th style="width:13%">Start Indoors</th><th style="width:14%">Sow / Transplant</th>' +
      '<th style="width:14%">Harvest</th>' +
      '<th style="width:7%">Spacing</th>' +
      '<th style="width:22%"><div class="pcd-pv-mo-head">' +
      ['J','F','M','A','M','J','J','A','S','O','N','D'].map(function(m) { return '<span>' + m + '</span>'; }).join('') +
      '</div></th>' +
      '</tr></thead><tbody>';

    // Ячейка с датами всех сезонов культуры (Spring: … / Fall: …)
    function pvSeasonCell(crop, key) {
      var parts = [];
      crop.seasonsRaw.forEach(function(s) {
        if (!s[key]) return;
        var lbl = (crop.seasonsRaw.length > 1 && s.season !== 'year-round') ? seasonLabel(s.season) + ': ' : '';
        parts.push(lbl + fmtSeasonRange(s[key]));
      });
      if (!parts.length) return '<span class="pcd-pv-empty">—</span>';
      return parts.map(function(t) { return '<span class="pcd-pv-date">' + esc(t) + '</span>'; }).join('<br>');
    }

    crops.forEach(function(crop) {
      // Три отдельных ряда бара, как на странице — harvest больше не прячет посев
      var barRows = [
        { ranges: crop.indoor,  color: SEG.indoor },
        { ranges: crop.outdoor, color: SEG.outdoor },
        { ranges: crop.harvest, color: SEG.harvest },
      ].map(function(row) {
        var arr = [0,0,0,0,0,0,0,0,0,0,0,0];
        row.ranges.forEach(function(r) {
          rangeToMonths(r).forEach(function(m) { arr[m.idx] = Math.max(arr[m.idx], m.cov); });
        });
        return '<div class="pcd-pv-bar">' + arr.map(function(v) {
          return v > 0
            ? '<div class="pcd-pv-bar-cell" style="background:' + row.color + ';opacity:' + (v > 0.6 ? '1' : '0.55') + '"></div>'
            : '<div class="pcd-pv-bar-cell" style="background:#eee"></div>';
        }).join('') + '</div>';
      }).join('');

      html += '<tr>' +
        '<td><div class="pcd-pv-name">' + esc(crop.name) + '</div>' +
        '<div style="margin-top:3px"><span class="pcd-pv-cat">' + esc(crop.category) + '</span></div></td>' +
        '<td>' + (crop.notes ? '<span class="pcd-pv-notes">' + esc(crop.notes) + '</span>' : '<span class="pcd-pv-empty">—</span>') + '</td>' +
        '<td>' + pvSeasonCell(crop, 'indoorStart') + '</td>' +
        '<td>' + pvSeasonCell(crop, 'sowOutdoor') + '</td>' +
        '<td>' + pvSeasonCell(crop, 'harvest') + '</td>' +
        '<td class="pcd-pv-spacing">' + esc(crop.spacing || '—') + '</td>' +
        '<td><div class="pcd-pv-bar-stack">' + barRows + '</div></td></tr>';
    });

    html += '</tbody></table>' +
      '<div class="pcd-pv-ft">' +
      '<span>Dates reflect long-term averages. Always watch your local weather.' +
      (omitted ? ' ' + omitted + ' crop(s) without local planting data omitted.' : '') + '</span>' +
      '<span>organorepublic.com</span></div>';
    el.innerHTML = html;
  }

  exportBtn.addEventListener('click', function() {
    if (!S.apiData) { alert('Please enter your ZIP code first to generate a planting calendar.'); return; }
    if (!filteredCrops().filter(function(c) { return c.hasData; }).length) {
      alert('No crops match the current filters — nothing to print.');
      return;
    }
    buildPrintView();
    var pv  = document.getElementById('pcd-print-view');
    var htm = pv.innerHTML;
    pv.innerHTML = '';
    var blob = new Blob([buildPrintHtml(htm)], { type: 'text/html' });
    var url  = URL.createObjectURL(blob);
    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;left:-9999px;top:0;width:297mm;height:210mm;border:0;';
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.addEventListener('load', function() {
      var iWin = iframe.contentWindow;
      var ready = iWin.document.fonts ? iWin.document.fonts.ready : Promise.resolve();
      ready.then(function() {
        iWin.focus(); iWin.print();
        iWin.addEventListener('afterprint', function() {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
          URL.revokeObjectURL(url);
        });
      });
    });
  });

})();
